import config from '../config'

export const timeout = (duration = 3000) => {
    return new Promise((resolve) => {
        setTimeout(function() {
            resolve();
        }, duration)
    });
}

export const clone = (obj) => {
    // Source: https://stackoverflow.com/a/728694

    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

export const companySchema = (company) => {

    const apiKey = config.googleMapsApiKey;

    const schemaJson = {
        "@context":"http://schema.org",
        "@type":"LocalBusiness",
        "legalName": company.Name,
        "name": company.Name,
        "sameAs": company.Url,
        "url": `http:/www.brabyggare.se/hantverkare/${company.Id}`,
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": '+46' + company.Phone,
            "contactType": "customer service",
            "email": company.Email
        },
        "telephone": '+46' + company.Phone,
        "description": company.Presentation,
        "image": company.Images ? company.Images[0] : '',
        "logo": company.Logo,
        "address": company.VisitAddress + ' ' + company.VisitCity,
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": company.Latitude,
            "longitude": company.Longitude
        },
        "hasMap": `https://www.google.com/maps/embed/v1/place?&q=${company.Latitude},${company.Longitude}&zoom=10&key=${apiKey}`,
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": company.Rating,
            "ratingCount": company.NrOfRatings,
            "bestRating": "5",
            "worstRating": "1",
        },
    }

    return schemaJson;
}

export const stripScriptTags = (value) => {
    const regex =  /<script[\s\S]*?>[\s\S]*?<\/script>/g;
    return regex.test(value) ? value.replace(regex, "") : value;
}



// WEBPACK FOOTER //
// ./src/helpers/index.js